// types
import { Transaction } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// headers
import { getTransactionsHeaders } from './TableBasicTransactions.headers';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// props
export interface TableBasicTransactionsProps extends Omit<TableProps, 'headers'> {
	currency?: string;
	hasConversions?: boolean;
	headersIncluded?: string[];
	data: Transaction[];
	loan?: number;
}

export const TableBasicTransactions = ({
	currency,
	hasConversions = true,
	headersIncluded = [
		'amount',
		'date',
		'expenseType',
		'evidenced',
		'recorded',
		'status',
		'tax',
		'total',
		'type',
		'updated',
	],
	data = [],
	loan,
	...props
}: TableBasicTransactionsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getTransactionsHeaders({
		currency,
		hasConversions,
		headersIncluded,
		loan,
		t,
	});

	return <Table {...props} data={data} headers={headers} />;
};
